import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { useNavigate } from 'react-router-dom';
import { useAuthenticationContext } from '../authentication.context';
import auth from '@/lib/auth';

const formSchema = z.object({
  email: z.string().email(),
});

export default function SignIn() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { setUserId } = useAuthenticationContext();

  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: { email: '' },
  });

  const onSubmit = async values => {
    setLoading(true);
    setError(null);

    const { data, error } = await auth.signInFlow({
      email: values.email,
    });

    setLoading(false);

    if (error) {
      setError(error);
      return;
    }

    setUserId(data.id);
    navigate('/authentication/verify');
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input
                  className="w-[500px]"
                  placeholder="email@c8health.com"
                  onFocus={() => setError(null)}
                  {...field}
                />
              </FormControl>
              {error && <Label className="mt-4 ml-1 text-red-500">{error}</Label>}
              <FormMessage />
            </FormItem>
          )}
        />

        <Button type="submit" className="mt-4" loading={loading}>
          Submit
        </Button>
      </form>
    </Form>
  );
}
